import React from 'react';
import PropTypes from 'prop-types';
import { MODAL_TYPE, CUSTOMER_SERVICE_CENTRE } from '../../constants';
import ModalTemplate from '../layout/ModalTemplate';
import TymeButton from '../../components/common/TymeButton';

export const ResetAttemptOTPModal = ({ isShow = false, onHide, onSubmit }) => {
    return (
        <ModalTemplate
            title="One-Time-Pin (OTP) limit exceeded"
            type={MODAL_TYPE.ERROR}
            isShow={isShow}
            handleHide={onHide}>
            <div>
                <p>You have exceeded your OTP resend attempts. Please try again later.</p>
                <p>
                    If you are experiencing any issues you can call our Customer Service Centre on{' '}
                    <span className="font-bold">{CUSTOMER_SERVICE_CENTRE}</span>.
                </p>
                <div className="btn-control-container">
                    <TymeButton onClick={onSubmit}>OK</TymeButton>
                </div>
            </div>
        </ModalTemplate>
    );
};

ResetAttemptOTPModal.propTypes = {
    isShow: PropTypes.bool,
    onHide: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default ResetAttemptOTPModal;
